import React, { memo } from 'react';
import { Button, makeStyles, Theme } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

interface Props {
  onDismissTooltip: (event?: React.MouseEvent<EventTarget>) => void;
  onClick: (event: any) => void;
}

const SpeakingWhileMutedTooltip = ({ onClick, onDismissTooltip }: Props) => {
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.title}>
        <FormattedMessage id="components.audioMute.title" defaultMessage={"Pssst, you're muted"} />
      </h3>
      <div className={classes.subTitle}>
        <FormattedMessage
          id="components.audioMute.subtitle"
          defaultMessage={'If you want others to hear you, click the button below to unmute yourself.'}
        />
      </div>
      <div className={classes.tipButtonBar}>
        <Button color="primary" onClick={onDismissTooltip} size="small">
          <FormattedMessage id="components.audioMute.dismiss" defaultMessage={'dismiss'} />
        </Button>
        <Button color="primary" onClick={onClick} size="small" variant="contained">
          <FormattedMessage id="components.audioMute.unmute" defaultMessage={'unmute'} />
        </Button>
      </div>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginTop: 0,
    fontSize: '1.13rem',
    fontWeight: 500
  },
  subTitle: {
    paddingTop: '12px',
    fontSize: '0.85rem',
    fontWeight: 400
  },
  tipButtonBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),

    '& > button': {
      textTransform: 'uppercase',
      style: 'normal',
      fontSize: '0.85rem',
      fontWeight: 400,

      '&:first-child': {
        flex: '0 0 auto',
        marginRight: theme.spacing(2)
      }
    }
  }
}));

export default memo(SpeakingWhileMutedTooltip);
